import api from 'Application/api/api';

const updateProjectDeveloper = (signal, values) =>
	api.put('/project-developers', values, {
		signal,
	});

export default updateProjectDeveloper;
